import { BreakpointObserver, Breakpoints } from '@angular/cdk/layout';
import { ChangeDetectorRef, Component, inject, OnChanges, OnDestroy, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { Subscription } from 'rxjs';
import { BendixDataExtractionDisclaimerComponent } from '../bendix-data-extraction-disclaimer/bendix-data-extraction-disclaimer.component';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { KbDataExtractionRequestService } from 'src/app/services/feature/data-extraction-request/kb-data-extraction-request.service';

@Component({
  selector: 'app-kb-data-extraction-overview',
  templateUrl: './kb-data-extraction-overview.component.html',
  styleUrl: './kb-data-extraction-overview.component.scss',
  standalone: false
})
export class KbDataExtractionOverviewComponent implements OnDestroy {

  isMobile: boolean;
  dialogConfig: any;

  allowNext = false;

  private dialog = inject(MatDialog)
  private BreakpointObserver = inject(BreakpointObserver);
  private subscription = new Subscription();
  private dataExtractionService = inject(KbDataExtractionRequestService);
  private cdr = inject(ChangeDetectorRef);
  dataExtractionOverviewForm = new FormGroup({
    valueDisclaimer: new FormControl({ value: false, disabled: true }, { validators: Validators.required }),
  });

  get form() {
    return this.dataExtractionOverviewForm;
  }

  constructor() {
    this.subscription.add(this.BreakpointObserver.observe([Breakpoints.XSmall, Breakpoints.Small])
      .subscribe(result => {
        this.isMobile = result.matches;
      }));
  }
  ngOnInit(): void {
    this.subscription.add(this.dataExtractionService.dataExtractionOverviewDataCheckeBox$
      .subscribe(checkboxValue => {
        this.dataExtractionOverviewForm.get('valueDisclaimer')?.patchValue(checkboxValue);
        this.allowNext = this.dataExtractionOverviewForm.get('valueDisclaimer').value;
        this.cdr.detectChanges();
        this.dataExtractionOverviewForm.get('valueDisclaimer')?.disable();
      }));
  }
  openBendixDataExtractionDisclaimer() {
    if (this.isMobile) {
      this.dialogConfig = {
        height: '540px',
        maxWidth: '93vw',
      }
    }
    else {
      this.dialogConfig = {
        width: '60vw',
        height: '83vh',
        maxHeight: '90vh',
        panelClass: 'waiver_popup_class',
      };
    }
    const dialogRef = this.dialog.open(BendixDataExtractionDisclaimerComponent, this.dialogConfig);
    dialogRef.afterClosed().subscribe((accepted) => {
      if (accepted === true) {
        this.dataExtractionOverviewForm.get('valueDisclaimer')?.patchValue(true);
        this.allowNext = this.dataExtractionOverviewForm.get('valueDisclaimer').value;
        this.cdr.detectChanges();
        this.dataExtractionOverviewForm.get('valueDisclaimer')?.disable();
        this.dataExtractionService.setDataExtractionOverviewData(true);
        this.dataExtractionService.nextComponentClick$.next(true);
      }
      else {
        this.dataExtractionOverviewForm.get('valueDisclaimer')?.patchValue(false);
        this.allowNext = this.dataExtractionOverviewForm.get('valueDisclaimer').value;
        this.cdr.detectChanges();
        this.dataExtractionOverviewForm.get('valueDisclaimer')?.disable();
        this.dataExtractionService.setDataExtractionOverviewData(false);
      }

    });
  }

  nextPage() {
    this.dataExtractionService.currentComponent$.next('customerVehicleOwner');
  }

  ngOnDestroy() {
    this.subscription.unsubscribe();
  }
}
